/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export const TWO_FACTOR_ENROLL_FLOWS = Object.freeze({
  SELECT_METHOD: 'SELECT_METHOD',
  SMS: 'SMS',
  AUTH_APP: 'AUTH_APP',
  AUTH_APP_ONLY: 'AUTH_APP_ONLY',
  CODE: 'CODE',
  FINISH: 'FINISH'
});
export const PHONE_DELIVERY_METHODS = Object.freeze({
  SMS: 'SMS',
  VOICE: 'VOICE'
});
let TwoFactorEnrollBaseComponent = (_dec = service('ember-multipass-flag'), _dec2 = service('ember-multipass-logging'), _dec3 = service('ember-multipassfe-client'), _class = class TwoFactorEnrollBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "flags", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "flows", TWO_FACTOR_ENROLL_FLOWS);
    _defineProperty(this, "methods", Object.freeze({
      SMS: 'SMS',
      AUTH_APP: 'AUTH_APP'
    }));
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _initializerDefineProperty(this, "dualEnrollSecureContactModalOpen", _descriptor5, this);
    _initializerDefineProperty(this, "flow", _descriptor6, this);
    _initializerDefineProperty(this, "method", _descriptor7, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor8, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor9, this);
    _initializerDefineProperty(this, "selectedDetail", _descriptor10, this);
    _initializerDefineProperty(this, "selectedPhoneDeliveryMethod", _descriptor11, this);
    _initializerDefineProperty(this, "shouldPromptForSecureContactEnrollment", _descriptor12, this);
    this.logger.addComponentBreadcrumb('TwoFactorEnrollBaseComponent');
    this.config = getOwner(this).resolveRegistration('config:environment');
    if (this.args.initialFlow && Object.values(TWO_FACTOR_ENROLL_FLOWS).includes(this.args.initialFlow)) {
      this.setFlow(this.args.initialFlow);
    } else {
      this.checkAuthAppOnlyRestriction();
    }
  }
  async handleDualEnrollSecureContactModalOpen() {
    // Only open dual 2FA -> SCM enroll modal if 2FA enrollment flow response indicated we should prompt
    this.dualEnrollSecureContactModalOpen = this.shouldPromptForSecureContactEnrollment;
  }
  checkAuthAppOnlyRestriction() {
    if (!this.multipassfeClient.canUseSms) {
      this.setFlow(this.flows.AUTH_APP_ONLY);
    }
  }
  setSelectedPhoneDeliveryMethod(newPhoneDeliveryMethod) {
    this.selectedPhoneDeliveryMethod = newPhoneDeliveryMethod;
  }
  setFlow(newFlow) {
    this.flow = newFlow;
    if (this.flow === this.flows.FINISH && this.method === this.methods.SMS) {
      this.handleDualEnrollSecureContactModalOpen();
    }
  }
  setMethod(newMethod) {
    this.method = newMethod;
  }
  setPhoneNumber(newPhoneNumber) {
    this.phoneNumber = newPhoneNumber;
  }
  setPhoneNumberDisplay(newPhoneNumberDisplay) {
    this.phoneNumberDisplay = newPhoneNumberDisplay;
  }
  setShouldPromptForSecureContactEnrollment(updatedShouldPromptForSecureContactEnrollment) {
    this.shouldPromptForSecureContactEnrollment = updatedShouldPromptForSecureContactEnrollment;
  }
  async resendSmsTwoFactorCodeDebounced() {
    debounce(this, this.resendSmsTwoFactorCode, 500, true);
  }
  async resendSmsTwoFactorCode() {
    try {
      if (this.selectedPhoneDeliveryMethod === this.phoneDeliveryMethods.VOICE) {
        return this.multipassfeClient.enrollTwoFactorVoice(this.phoneNumber);
      }
      return this.multipassfeClient.enrollTwoFactorSms(this.phoneNumber);
    } catch (e) {
      switch (e.message) {
        case 'TEMPORARY_LOCKOUT':
          break;
        default:
          this.logger.sentryError(e);
      }
    }
  }
  navigateToMethodFlow() {
    if (!this.multipassfeClient.canUseSms) {
      this.setFlow(this.flows.AUTH_APP_ONLY);
    } else if (this.method === this.methods.SMS) {
      this.setFlow(this.flows.SMS);
    } else if (this.method === this.methods.AUTH_APP) {
      this.setFlow(this.flows.AUTH_APP);
    }
  }
  handleDualEnrollSecureContactModalClose() {
    this.dualEnrollSecureContactModalOpen = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dualEnrollSecureContactModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.SELECT_METHOD;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "method", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedDetail", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectedPhoneDeliveryMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.phoneDeliveryMethods.SMS;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "shouldPromptForSecureContactEnrollment", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumberDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumberDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShouldPromptForSecureContactEnrollment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShouldPromptForSecureContactEnrollment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToMethodFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToMethodFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDualEnrollSecureContactModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDualEnrollSecureContactModalClose"), _class.prototype), _class);
export { TwoFactorEnrollBaseComponent as default };